import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    setBusy(true);
    const r = await api<{ ok?: boolean }>("/api/auth/forgot-password", {
      method: "POST",
      body: JSON.stringify({ email: email.trim() }),
    });
    setBusy(false);
    if (!r.ok) {
      setError(r.error || "Request failed");
      return;
    }
    setSent(true);
  }

  return (
    <div className="layout">
      <main className="layout-main layout-main--narrow">
        <h1>Reset password</h1>
        {sent ? (
          <p className="muted">
            If an account exists for that email, we sent a reset link. Check your inbox and spam
            folder.
          </p>
        ) : (
          <>
            <p className="muted">We&apos;ll email you a link to choose a new password.</p>
            <p className="muted" style={{ fontSize: "0.9rem" }}>
              Use the same email you registered with. If you only sign in through Cloudflare Access,
              password reset does not apply. Successfully sent links are limited to{" "}
              <strong>10 per address per 24 hours</strong>.
            </p>
            <form className="card" onSubmit={submit}>
              <div className="field">
                <label htmlFor="fp-email">Email</label>
                <input
                  id="fp-email"
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              {error ? <p className="error">{error}</p> : null}
              <button type="submit" className="btn btn-primary" disabled={busy} style={{ width: "100%" }}>
                {busy ? "Sending…" : "Send reset link"}
              </button>
            </form>
          </>
        )}
        <p className="muted" style={{ marginTop: "1rem" }}>
          <Link to="/login">Back to sign in</Link>
        </p>
      </main>
    </div>
  );
}
